import React from "react";
import PropTypes from "prop-types";

export default function ProfileGridCard({ item, onSelect }) {
  const isCompany = item.type === "company";

  return (
    <div
      className="profile-grid-card"
      onClick={() => onSelect && onSelect(item)}
      role="button"
    >
      <div className="profile-grid-imgwrap">
        <img src={item.image} alt={item.title} className="profile-grid-img" />
      </div>

      <div
        className={
          "profile-grid-titlebar" +
          (isCompany ? " profile-grid-titlebar--blue" : "")
        }
      >
        {item.title}
      </div>

      <div className="profile-grid-body">
        {item.role && <p className="profile-grid-role">{item.role}</p>}
        {(item.location || item.followers != null) && (
          <p className="profile-grid-meta">
            {item.location && (
              <>
                <i className="fas fa-map-marker-alt"></i> {item.location}{" "}
              </>
            )}
            {/* {item.followers != null && <>👥 {item.followers} Followers</>} */}
          </p>
        )}
        {item.description && (
          <p className="profile-grid-desc">{item.description}</p>
        )}
      </div>
    </div>
  );
}

ProfileGridCard.propTypes = {
  item: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
};
